import 'Generic/styles/style.css';
import 'Generic/styles/products-info-modals-v2.css';
import './styles/style.css';
import './styles/proPlan.css';
import {store, setState, fieldsValidation, GpayGateway, ApplePayGateway, constant} from 'Generic';
import PackageBoxes from './components/packageBoxes';
import planBoxes from './components/planBoxes';
import Gateways from './components/gateways';
import OrderSummary from './components/orderSummary';
import CheckoutForm from './components/checkoutForm';
import Incentive from './components/incentive';
import GatewayIncentive from './components/gatewayIncentive';
import {
  getGpayOnGatewayChange,
  addAddon,
  selectPlan,
  removeAddon,
  applyCouponCode,
  removeCouponCode,
  showCouponResponcse,
  splitIntoFirstAndSecondName,
  selectGateway,
  removeInputError,
  getSelectedGatewayOnLoad,
  addClass,
  removeClass,
  resetPaymentAndIncentive,
  GA4addPaymentInfoEvent,
  sendGa4CustomEvent,
  gmailDomainCorrection,
  openCustomModal,
  closeCustomPopup,
} from 'Generic/lib';
import 'Generic/lib/tweet';

/* Setting Global Variables */
window.recurlyCardFields.recurlyCardNumber = '0000  0000  0000  0000';
window.base_url = window.location.origin;
window.conditionalGateways = {
  applepay: false,
  gatepay:
    (/android/i.test(navigator.userAgent) && 'gateio' in window) || //to show gatepay in android app
    (['iPad', 'iPhone'].includes(navigator?.userAgentData?.platform || navigator?.platform) &&
      typeof window.webkit?.messageHandlers?.gatepay === 'object'), //to show gatepay in iOS opp
};
window.applePay = {};
window.renderComponents = renderComponents;

/* Cart State */
let cartState = store.state.cartState ? store.state.cartState : {};

/* Parsing cart params data */
let keysToBeParsed = [
  'plans',
  'plans_currency',
  'old_prices',
  'special_addons_old_prices',
  'gateway_incentives',
  'hidden_packages_currency',
  'hidden_packages',
  'hidden_packages_currency',
  'hidden_products_association',
];
let parsedData = {};
keysToBeParsed.map(key => {
  let stateData = cartState[key];
  if (stateData) {
    parsedData = {...parsedData, [key]: JSON.parse(stateData)};
  }
});
setState(parsedData);

/* Setting usefull data in variables to reuse */
const showAsSelected = cartState?.plans[0]?.labels?.show_as_selected;
const selectedPlanIndex = showAsSelected ? showAsSelected - 1 : 0;

const selectedPlan = cartState.plans[selectedPlanIndex] ? cartState.plans[selectedPlanIndex] : {};
setState({selected_plan: selectedPlan, proplan_index: '0'});

/* Adding selected gateway in state */
if (cartState) {
  let selectedGateway = getSelectedGatewayOnLoad();
  if (selectedGateway.gateway_key) {
    setState({
      selected_gateway: selectedGateway.gateway_key,
      selected_gateway_name: selectedGateway.gateway_name,
    });
  }
}

/* Cart package boxes select event */
document.querySelectorAll('.cart-box').forEach((cartBox, index) => {
  cartBox?.addEventListener(
    'click',
    () => {
      resetPaymentAndIncentive();

      const tabElement = cartBox.getAttribute('data-tab-code');
      addClass(`.plan-tabs-wrap ul [data-tabs="${tabElement}"]`, 'active');
      const proplan_index = cartBox.getAttribute('data-key');
      let newSelectedPlan = cartState.plans[index] ? cartState.plans[index] : {};
      if (newSelectedPlan?.visible_plan_code !== cartState.selected_plan?.visible_plan_code) {
        selectPlan(index, {proplan_index, proplan_code: null});
      }
    },
    true,
  );
});

// Handling clicks on 'plan-table' cells: triggers a row click and highlights the entire column.
document.querySelectorAll('td.plus-border-v2').forEach((elem, index) => {
  elem?.addEventListener('click', e => {
    const customAttributeValue = elem.getAttribute('data-key');
    const parentTable = elem.closest('table');
    const clickableRow = parentTable?.querySelector(`tr.top-order .cart-box[data-key="${customAttributeValue}"]`);

    if (clickableRow) {
      clickableRow.click();
    }

    const columnIndex = elem.cellIndex;
    const cells = document.querySelectorAll('td, th');
    cells.forEach(cell => {
      cell.classList.remove('selected');
    });

    const rows = document.querySelectorAll('tr');
    rows.forEach(row => {
      const cellsInColumn = row.cells;
      if (cellsInColumn[columnIndex]) {
        cellsInColumn[columnIndex].classList.add('selected');
      }
    });
  });
});

/* Cart gateway select event */
let gatewaysWrapper = document.querySelector('#payment_gateways');
let incentiveElement = document.querySelector('#hidden-product-wrapper');
gatewaysWrapper?.addEventListener('click', function (e) {
  let target = e.target;
  if (target.matches('.payment_selection_box, .payment_selection_box *')) {
    e.stopPropagation();

    let gatewayKey = target.getAttribute('data-name');
    let gatewayName = target.getAttribute('data-gateway-text');
    if (!gatewayKey) {
      gatewayKey = target.closest('.payment_selection_box').getAttribute('data-name');
      gatewayName = target.closest('.payment_selection_box').getAttribute('data-gateway-text');
    }
    if (incentiveElement) {
      incentiveElement.style.display = 'none';
    }

    selectGateway(gatewayKey, gatewayName);
    getGpayOnGatewayChange(gatewayKey, GatewaysInstance);
  }
});

/* Coupon Events */
let couponToggle = document.getElementById('coupon-toggle');
couponToggle?.addEventListener('click', () => {
  document.querySelector('.payment-coupon-box').classList.toggle('active');
  document.querySelector('.payment-coupon-box-message').classList.toggle('active');
  document.querySelector('#coupon-input').focus();
});

function applyCouponSubmit() {
  let couponInputValue = document.querySelector('#coupon-input').value;
  if (couponInputValue !== '') {
    if (!couponInputValue.includes('fpdr')) {
      applyCouponCode(couponInputValue);
    } else {
      showCouponResponcse(false);
    }
  }
}

let couponSubmitButton = document.getElementById('coupon-submit');
couponSubmitButton?.addEventListener('click', applyCouponSubmit);

let couponRemoveButton = document.querySelector('.payment-coupon-cancel');
couponRemoveButton?.addEventListener('click', removeCouponCode);

let couponInputField = document.querySelector('#coupon-input');
couponInputField?.addEventListener('focusout', e => {
  let couponValue = e.target.value;
  if (!couponValue) removeCouponCode();
});

couponInputField.addEventListener('keypress', e => {
  if (e.which == 13) {
    e.preventDefault();
    applyCouponSubmit();
  }
});

/* Show password event */
let showPasswordButton = document?.querySelector('.password-eye-icon');
showPasswordButton?.addEventListener('click', () => {
  let passwordInputField = document?.querySelector('#input_password');
  let type = passwordInputField.type === 'text' ? 'password' : 'text';

  passwordInputField.type = type;
});

/* User information input fields */
let paymentForm = document.querySelector('#payment-form');
paymentForm?.addEventListener('keyup', function (e) {
  let target = e.target;
  e.stopPropagation();

  if (target.matches('#input_name,#input_email,#input_password')) {
    if (target.value) fieldsValidation(target);
    removeInputError(target);
  }
});

paymentForm?.addEventListener('focusout', function (e) {
  let target = e.target;
  e.stopPropagation();

  if (target.matches('#input_name,#input_email,#input_password') && target.value) {
    const isValid = fieldsValidation(target);
    if (target.matches('#input_email') && isValid) {
      let correctDomain = gmailDomainCorrection(target.value);
      if (correctDomain) {
        target.value = correctDomain;
      }
    }
    if (window.isPaymentInfoEventSent === false && target.matches('#input_email') && isValid) {
      //send payment info event into GA4
      sendGa4CustomEvent('signup_email_push', {email: target.value});
      GA4addPaymentInfoEvent();
    }
  }

  if (target.matches('#input_name')) {
    let recurlyFirstNameElement = document.querySelector('[data-recurly="first_name"]');
    let recurlyLastNameElement = document.querySelector('[data-recurly="last_name"]');
    const [firstName, lastName] = splitIntoFirstAndSecondName(target.value);

    recurlyFirstNameElement.value = firstName || 'N/A';
    recurlyLastNameElement.value = lastName || 'N/A';
  }
});

/* VAT events */
const allCountries = cartState.all_countries ? cartState.all_countries : [];
const gatewayTaxSummary = document.querySelector('.tax-summary');
const taxSelected = document.querySelector('.tax-selected');
const optionsContainer = document.querySelector('.options-container');
const taxSelectbox = document.querySelector('.tax-selectbox');
const countrySearch = document.querySelector('#country-search');
const selectedCountryHiddenField = $("input[data-recurly='country']");
let selectedOption = document.querySelector('.country-option.option-selected .radio');

if (gatewayTaxSummary) {
  taxSelected.addEventListener('click', e => {
    e.stopPropagation();
    taxSelectbox.classList.toggle('active');
    countrySearch.focus();
  });

  document.addEventListener('click', e => {
    if (e.target !== countrySearch) {
      taxSelectbox.classList.remove('active');
    }
  });

  optionsContainer.addEventListener('click', function (e) {
    let optionElement;

    //TODO: Remove jQuery code
    if ($(e.target).hasClass('country-option')) {
      optionElement = e.target;
    } else {
      optionElement = $(e.target).parent('.country-option')[0];
    }

    if (optionElement) {
      var previous = document.querySelector('.option-selected');
      previous && previous.classList.contains('option-selected') && previous.classList.remove('option-selected');
      selectedOption = optionElement.querySelector('.radio');
      let selectedCountryCode = optionElement.querySelector('.radio').value;
      taxSelected.innerHTML = optionElement.querySelector('label').innerHTML;
      optionElement.className += ' option-selected';
      setState({user_country: selectedCountryCode});
      selectedCountryHiddenField.val(selectedCountryCode);
      taxSelectbox.classList.remove('active');
    }
  });

  countrySearch.addEventListener('keyup', function (e) {
    let res = '';

    allCountries.map(val => {
      if (val.country_name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1) {
        res += `<div class="country-option ${selectedOption.value == val.iso2 ? 'option-selected' : ''}">
                      <input type="radio" class="radio" id="vat-${val.iso2}" name="Country" value="${val.iso2}">
                      <img loading="lazy" src="https://images.purevpn-tools.com/public/images/tickmark-dropdown.png" alt="" class="img-responsive img-selected">
                      <label for="${val.iso2}">${val.country_name}</label>
                  </div>`;
      }
    });

    optionsContainer.innerHTML = res;
  });
}

/* Cart Tabs */
const tabsWrapper = document.querySelector('.plan-tabs-wrap ul');
tabsWrapper?.addEventListener('click', function (e) {
  let target = e.target;

  if (target.matches('li, li *')) {
    e.stopPropagation();

    let tabName = target.getAttribute('data-tabs');
    if (!tabName) {
      target = target.closest('li');
      tabName = target.getAttribute('data-tabs');
    }

    // acordion animation
    const planboxContent = document.querySelectorAll('.planbox-content');
    planboxContent.forEach(item => {
      const nextElementSibling = item.nextElementSibling;
      item.classList.remove('active');
      nextElementSibling.classList.remove('accord-anim-exp');
      nextElementSibling.classList.remove('accord-anim-col');
    });

    // SLiding Tabs
    slidingTab(target);

    removeClass('.plan-tabs-wrap ul li', 'active');
    target.classList.add('active');

    // tab punch line
    showTabPunchLine(tabName);

    removeClass('.plan-box-wrapper', 'active');
    const currentPlanBox = document.querySelector(`.plan-box-wrapper.${tabName}`);
    if (tabName && currentPlanBox) {
      currentPlanBox.classList.add('active');
    }

    const defaultSelectedPlanType = cartState?.defaultSelectedPlanType;
    if (defaultSelectedPlanType) {
      const dataPlanType = defaultSelectedPlanType.getAttribute('data-plan-type');
      const tabs = document.querySelectorAll('.plan-box-wrapper.active [data-plan-type="' + dataPlanType + '"]');

      if (tabs?.length > 0) {
        tabs.forEach(e => {
          e.click();
        });
      } else {
        const planIndex = target.getAttribute('data-plan-index').split(',');
        const indexLen = planIndex.length > 0 ? planIndex.length - 1 : 0;

        if (planIndex[0]) {
          document.querySelectorAll(`.pro-cart-container [data-plan-index="${planIndex[indexLen]}"]`).forEach(e => {
            e.click();
          });
        }
      }
    } else {
      let planIndex = target.getAttribute('data-plan-index');
      planIndex = planIndex.split(',');
      if (planIndex[0]) {
        document.querySelectorAll('.pro-cart-container [data-plan-index="' + planIndex[0] + '"]').forEach(e => {
          e.click();
        });
      }
    }
  }
});

/* Render Components */
function renderComponents() {
  const OrderSummaryInstance = new OrderSummary();
  OrderSummaryInstance.render();

  const CheckoutFormInstance = new CheckoutForm();
  CheckoutFormInstance.render();

  GpayGateway.loadGooglePayIfApplicable();
  ApplePayGateway.loadApplePayIfApplicable(GatewaysInstance);
}

const GatewaysInstance = new Gateways();
GatewaysInstance.render();

const IncentiveInstance = new Incentive();
IncentiveInstance.render();

const GatewayIncentiveInstance = new GatewayIncentive();
GatewayIncentiveInstance.render();

// To generate plan change functionality
const packageBoxesInstance = new PackageBoxes();
packageBoxesInstance.render();

const PlanBoxesInstance = new planBoxes();
PlanBoxesInstance.render();

$('.pro-btn').click(function () {
  $('html,body').animate(
    {
      scrollTop: $('#gateway-for-scroll').offset().top,
    },
    'slow',
  );
});

function slidingTab(elem) {
  if (elem) {
    const slideTabBox = document.querySelector('.pro-cart-wrapper li .tab-link-background');
    const tabsBox = document.querySelector('.pro-cart-wrapper .plan-tabs-wrap.currency ul');

    const tabsBoxLeft = tabsBox?.getBoundingClientRect();
    const selectedTabBox = elem?.getBoundingClientRect();
    const slideTab = slideTabBox?.getBoundingClientRect();

    let posMargin = 6;

    if (window?.innerWidth <= 768) {
      posMargin = 4;
    }

    if (selectedTabBox && slideTab) {
      const calcWidth = selectedTabBox.left - tabsBoxLeft.left - posMargin; //tabsBox.offsetLeft
      slideTabBox.style.left = `${calcWidth}px`;
    }
  }
}

const selectedTab = document.querySelector('.pro-cart-wrapper .plan-tabs-wrap.currency ul li.active');
if (selectedTab) {
  slidingTab(selectedTab);
}

window.addEventListener('resize', function (event) {
  // Sliding Tabs
  const selectedTab = document.querySelector('.pro-cart-wrapper .plan-tabs-wrap.currency ul li.active');
  slidingTab(selectedTab);
});

// Tab Punch Line Beneath Cart Tabs
function showTabPunchLine(tabName) {
  const punchLineList = document.querySelectorAll('.tab-punch-line-box .punch-line');
  punchLineList.forEach(item => {
    const dataTab = item.getAttribute(`data-tabs`);
    if (dataTab === tabName) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}

document.addEventListener('click', function (e) {
  const target = e.target;
  let popupCheck = false;

  /* Product information popup button click listner */
  if (target.matches('.product_popup_link, .product_popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    let productCode = target.getAttribute('product-code');

    if (!productCode) {
      productCode = target.closest('.product_popup_link').getAttribute('product-code');
    }

    const productHtml = document.querySelector(`#${productCode}_info_popup`);

    if (productHtml) {
      const modalId = `customcartPopup_${productCode}`;
      let modalHtmlContent = productHtml.innerHTML;
      let modalClass = 'modalProductInfoClass';

      let productType;
      if (productCode.startsWith('purevpn_')) {
        productType = 'purevpn';
      } else if (productCode.startsWith('purekeep_')) {
        productType = 'purekeep';
      } else if (productCode.startsWith('purecrypt_')) {
        productType = 'pureencrypt';
      } else if (productCode.startsWith('purescan_')) {
        productType = 'pureprivacy';
      }

      if (productType) {
        modalClass += ` ${productType}_product_bg`;
      }

      openCustomModal(modalHtmlContent, modalId, modalClass, '620px', false);
    }
  }

  if (target.matches('.product-btn, .product-btn *') && !popupCheck) {
    e.stopPropagation();
    closeCustomPopup();
  }

  /* Addon information popup button click listner */
  if (target.matches('.popup_link, .popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    let addonCode = target.getAttribute('addon-code');

    if (!addonCode) {
      addonCode = target.closest('.popup_link').getAttribute('addon-code');
    }

    let addonHttml = document.querySelector(`#${addonCode}_info_popup`);

    const modalId = `customcartPopup_${addonCode}`;

    let modalHtmlContent = addonHttml.innerHTML;

    openCustomModal(modalHtmlContent, modalId, 'modalAddonInfoClass');
  }
});

// Mobile Accordion
const mobileAcordion = document.querySelectorAll('.pro-cart-box-btn-wrap.order-box');
mobileAcordion?.forEach(item => {
  item.addEventListener('click', e => {
    const target = e.target;
    e.stopPropagation();

    const parentElem = target.closest('.planbox-content');
    const nextElementSibling = parentElem.nextElementSibling;

    parentElem.classList.toggle('active');

    if (parentElem.classList.contains('active')) {
      nextElementSibling.classList.add('accord-anim-exp');
      nextElementSibling.classList.remove('accord-anim-col');
    } else {
      nextElementSibling.classList.add('accord-anim-col');
      nextElementSibling.classList.remove('accord-anim-exp');
    }
  });
});

// For default plan selection on tab change
const defaultSelectedPlanType = document.querySelector('.pro-cart-container .cart-box.active');
setState({defaultSelectedPlanType});
